/*
 * The ONE "New Agentlet" menu. Every create entry point (Outcomes,
 * Agentlets header + empty-state, Governance Hub, GEL page) renders this
 * instead of hand-rolling its own dropdown — so the archetype list, the RBAC
 * gating, and the agent.create permission gate can never drift between
 * surfaces again. See data/agentArchetypes.jsx for the taxonomy.
 *
 * The caller supplies `onPick(archetypeKey)`:
 *   - on the Agentlets page → openCreate(key) (opens the flow in place)
 *   - off the page          → navigate(agentCreateRoute(key))
 */
import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from './Button';
import { MenuDropdown } from './MenuDropdown';
import { useAuth } from '../../contexts/AuthContext';
import { buildNewAgentletItems } from '../../data/agentArchetypes';

export default function NewAgentletMenu({
  onPick,
  label = 'New Agentlet',
  size = 'md',
  variant = 'primary',
}) {
  const { hasPermission } = useAuth();

  // Single place the agent.create gate lives for the create affordance.
  if (typeof hasPermission === 'function' && !hasPermission('agent.create')) {
    return null;
  }

  // SysLet is intentionally absent from this menu (platform-managed, not
  // user-authored — see agentArchetypes.jsx). No PA/SA gating needed here.
  const items = buildNewAgentletItems({ onPick });

  return (
    <MenuDropdown
      trigger={
        <Button variant={variant} size={size} iconLeft={<Plus size={13} />}>
          {label}
        </Button>
      }
      items={items}
    />
  );
}
